'use client';

import React, { useMemo } from 'react';

import { Rows } from '@bytel/trilogy-react';

import { WallType } from '@app-types/config';
import { ProductChildFull, ProductFeatureType, ProductParentFull } from '@app-types/product';

import { CategoryBox, CustomizationCategory, Stock } from '@product-detail/components';
import { ClickEvent } from '@trilogy-ds/react/lib/events/OnClickEvent';

export type CustomizationProps = {
    type: WallType;
    features: ProductParentFull['features'];
    featuresRules: ProductParentFull['featuresRules'];
    currentProduct: ProductChildFull;
    handleProductChange: (color: string, capacity?: string) => void;
    openShopAvailabilityModal: ClickEvent;
    isRenewal: boolean;
};

export function Customization({
    type,
    features,
    featuresRules,
    currentProduct,
    handleProductChange,
    openShopAvailabilityModal,
    isRenewal,
}: Readonly<CustomizationProps>) {
    const title = useMemo(() => {
        switch (type) {
            case WallType.HOTSPOT:
                return 'Je personnalise mon hotspot';
            case WallType.ACCESSORY:
            case WallType.SALES_ACCESSORY:
                return 'Je personnalise mon accessoire';
            case WallType.PHONE:
            case WallType.SALES_PHONE:
            default:
                return 'Quel modèle voulez-vous\u00A0?';
        }
    }, [type]);

    return (
        <CategoryBox title={title} formId='customizations'>
            <Rows gap={5}>
                {features.color.length > 0 && (
                    <CustomizationCategory
                        title='La couleur'
                        currentProduct={currentProduct}
                        featuresKey={ProductFeatureType.COLOR}
                        featuresRules={featuresRules}
                        features={features}
                        handleProductChange={handleProductChange}
                    />
                )}
                {features.capacity.length > 0 && (
                    <CustomizationCategory
                        title='La mémoire'
                        currentProduct={currentProduct}
                        featuresKey={ProductFeatureType.CAPACITY}
                        features={features}
                        featuresRules={featuresRules}
                        handleProductChange={handleProductChange}
                    />
                )}
                <Stock
                    type={type}
                    currentProduct={currentProduct}
                    openModal={openShopAvailabilityModal}
                    isRenewal={isRenewal}
                />
            </Rows>
        </CategoryBox>
    );
}
